<template>
  <div
    v-bind:class="amplifyUI.formSection"
    v-bind:data-test="auth.confirmSignIn.section"
  >
    <div
      v-bind:class="amplifyUI.sectionHeader"
      v-bind:data-test="auth.confirmSignIn.headerSection"
    >
      {{ options.header }}
    </div>
    <p
      class="authentication__mfa-code-message"
      v-if="options.user.challengeName === 'SMS_MFA'"
    >
      {{ $Amplify.I18n.get('Apply code from SMS') }}
    </p>
    <p class="authentication__mfa-code-message" v-else>
      {{ $Amplify.I18n.get('Apply code from MFA app') }}
    </p>
    <div
      v-bind:class="amplifyUI.sectionBody"
      v-bind:data-test="auth.confirmSignIn.bodySection"
    >
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">
          {{ $Amplify.I18n.get('Code') }} *
        </div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="code"
          :placeholder="$Amplify.I18n.get('Code')"
          v-bind:data-test="auth.confirmSignIn.codeInput"
        />
      </div>
      <div v-bind:class="amplifyUI.formField">
        <b-checkbox
          v-model="rememberDevice"
          class="b-checkbox--authentication"
          >{{ $Amplify.I18n.get('Remember this device') }}</b-checkbox
        >
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button
          v-bind:class="amplifyUI.button"
          v-on:click="submit"
          :disabled="!code"
          v-bind:data-test="auth.confirmSignIn.confirmButton"
        >
          {{ $Amplify.I18n.get('Confirm') }}
        </button>
      </span>
      <span v-bind:class="amplifyUI.sectionFooterSecondaryContent">
        <a
          v-bind:class="amplifyUI.a"
          v-on:click="signIn"
          v-bind:data-test="auth.confirmSignIn.backToSignInLink"
          >{{ $Amplify.I18n.get('Back to Sign In') }}</a
        >
      </span>
    </div>
    <div class="error" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue';
import * as AmplifyUI from '@aws-amplify/ui';
import { auth } from 'aws-amplify-vue/src/assets/data-test-attributes';

export default {
  name: 'ConfirmSignInCustom',
  props: ['confirmSignInConfig'],
  data() {
    return {
      verifyAttr: '',
      code: '',
      error: '',
      logger: {},
      amplifyUI: AmplifyUI,
      auth,
      rememberDevice: false,
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get('Confirm Sign In'),
        user: {},
      };
      return Object.assign(defaults, this.confirmSignInConfig || {});
    },
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
    if (Object.keys(this.options.user).length === 0) {
      this.setError('Valid user not received.');
    }
  },
  methods: {
    submit() {
      this.storeRememberDevice();
      this.$Amplify.Auth.confirmSignIn(
        this.options.user,
        this.code,
        this.options.user.challengeName,
      )
        .then(() => {
          this.logger.info('confirmSignIn successs');
          AmplifyEventBus.$emit('authState', 'signedIn');
        })
        .catch((e) => this.setError(e));
    },
    signIn() {
      AmplifyEventBus.$emit('authState', 'signIn');
    },
    setError(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    },
    storeRememberDevice() {
      this.$store.commit('auth/setRememberDevice', this.rememberDevice);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@aws-amplify/ui/dist/style.css';

[class^='Form__formField'] {
  ::v-deep .b-checkbox.checkbox .control-label {
    color: $primary;
    font-size: 16px;
    padding-left: 16px;
  }
}

.authentication__mfa-code-message {
  margin-bottom: 20px;
}
</style>
